import classes from './ModalAction.module.css';
import Button from '../../Components/UI/Button';
import clsx from 'clsx';
const ModalAction = ({
  isApiCall,
  disabled,
  confirmText,
  isCancel = true,
  className,
  onCancel,
  type = 'button',
  onConfirm
}) => {
  return (
    <div
      className={clsx(classes.btnsBox, {
        [className]: className
      })}>
      {isCancel && (
        <Button
          variants="cancel"
          onClick={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
          className={classes.cancelBtn}>
          Cancel
        </Button>
      )}
      <Button
        variants="confirm"
        className={classes.confirmBtn}
        onClick={() => {
          if (typeof onConfirm === 'function') onConfirm();
        }}
        type={type}
        disabled={isApiCall || disabled}>
        {isApiCall ? 'Wait..' : confirmText ? confirmText : 'Confirm'}
      </Button>
    </div>
  );
};

export default ModalAction;
